// EmailJS Configuration
// Replace these values with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
  PUBLIC_KEY: "lRhS4XN0l_xDBXYKy", // Your EmailJS public key
  SERVICE_ID: "service_jmzudm6", // Your EmailJS service ID
  TEMPLATE_ID: "template_ya5diyk", // Your EmailJS template ID
};

// You can also use environment variables if you prefer:
// export const EMAILJS_CONFIG = {
//   PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
//   SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
//   TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
// }; 